import React from "react";
import { useTranslation } from "react-i18next";
import TopBar from '../../components/TopBar'
import Footer from '../../components/Footer'
import { Fade } from "react-awesome-reveal";
import { isMobileDevice } from "../../utils";
import { useNavigate } from "react-router";
import Videos1 from "./components/videos1"
import { Swiper, SwiperSlide } from 'swiper/react';
import More from "./components/more";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  return (
    <div className="">
      <TopBar />
      <div className="relative"
        style={{
          backgroundImage: `url(${require("../../assets/image/icon15.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }} >
        <div className="text-[#181512] text-[45px] py-[118px] font-[700] w-[955px] mx-auto 
        h5:text-center h5:text-[30px] h5:w-full h5:py-[68px] relative z-10">影音專區</div>

        <div className="absolute top-0 left-0 right-0 bottom-0"
          style={{
            background: 'linear-gradient(to right, #fbfbfbc2, transparent)',
            bottom: '0',
            content: "",
            left: '0',
            pointerEvents: 'auto',
            position: 'absolute',
            right: '0',
            top: '0',
            zIndex: 1
          }}></div>
      </div>

      <div className="w-[740px] mx-auto mb-[75px] h5:w-full">
        <Fade
          cascade={true}
          direction="up"
          delay={200}
          duration={800}
          triggerOnce={true}
        >
          <div className="mt-[75px] h5:mt-[30px]">
            <Videos1 bgImg={require("../../assets/image/video/icon1.jpg")}
              videoUrl="9g5-WlOVlZM"
            />
            <div className="text-[#181512] text-[26px] font-bold mt-[30px] mb-5 h5:px-16">學徒起家變老闆 深耕台灣市場變龍頭</div>
            <div className="text-[#595959] text-[16px] h5:px-16">
              去年房市交易熱絡，帶動家具需求隨之攀升，家具業者對這情形有什麼看法? 外商家具業者如何看台灣市場? 顧客買賣愛殺價，如何堅持原則不虧損? 台灣連鎖家具龍頭的老闆，在人生低潮時，瀕臨破產，他如何力挽狂瀾渡過層層危機?
            </div>
          </div>
        </Fade>
        <Fade
          cascade={true}
          direction="up"
          delay={200}
          duration={800}
          triggerOnce={true}
        >
          <div className="mt-[75px] h5:mt-[30px]">
            <Videos1 bgImg={require("../../assets/image/video/icon2.jpg")}
              videoUrl="4io4SlieW9A"
            />
            <div className="text-[#181512] text-[26px] font-bold mt-[30px] mb-5 h5:px-16">SCANTEAK 詩肯柚木。四季皆宜的設計家具</div>
            <div className="text-[#595959] text-[16px] h5:px-16">
              詩肯柚木與國際知名設計團隊Outofstock Design的首次合作，解決了較小居住空間的挑戰。
            </div>
          </div>
        </Fade>
        <Fade
          cascade={true}
          direction="up"
          delay={200}
          duration={800}
          triggerOnce={true}
        >
          <div className="mt-[75px] h5:mt-[30px]">
            <Videos1 bgImg={require("../../assets/image/video/icon3.png")}
              videoUrl="3q7BJBNT3T8"
            />
            <div className="text-[#181512] text-[26px] font-bold mt-[30px] mb-5 h5:px-16">STUDY 三用櫃「開始享受整理的喜悅」</div>
            <div className="text-[#595959] text-[16px] h5:px-16">
              詩肯柚木為現代都市人打造出最完美的居家環境。
            </div>
          </div>
        </Fade>
        <Fade
          cascade={true}
          direction="up"
          delay={200}
          duration={800}
          triggerOnce={true}
        >
          <div className="mt-[75px] h5:mt-[30px]">
            <Videos1 bgImg={require("../../assets/image/video/icon4.png")}
              videoUrl="CFui9qXtYoU"
            />
            <div className="text-[#181512] text-[26px] font-bold mt-[30px] mb-5 h5:px-16">享受北歐生活 新品上市
            </div>
            <div className="text-[#595959] text-[16px] h5:px-16">
              適意的身心放鬆，是人們對居家住所最熱烈的渴望與享受。
            </div>
          </div>
        </Fade>
      </div>


      <More />

      <Footer />
    </div>
  );
};

export default ComponentName;
